(function () {
  'use strict';

  var API_ORIGIN = 'https://checkout.slimava.com';
  var SORTS = [
    ['recent', 'Most recent'], ['highest', 'Highest rating'], ['lowest', 'Lowest rating'],
    ['pictures', 'Only pictures'], ['pictures_first', 'Pictures first']
  ];
  var mounted = new WeakMap();
  var instanceCount = 0;

  function pageChoices(current, pages) {
    var result = [];
    for (var i = 1; i <= pages; i += 1) {
      if (i === 1 || i === pages || Math.abs(i - current) <= 1) {
        if (result.length && i - result[result.length - 1] > 1) result.push('…');
        result.push(i);
      }
    }
    return result;
  }

  function pictureUrl(value) {
    try {
      var url = new URL(value, API_ORIGIN);
      if (url.protocol !== 'https:' || url.username || url.password) return null;
      if (!['checkout.slimava.com', 'slimava.com', 'www.slimava.com', 'cdn.shopify.com'].includes(url.hostname)) return null;
      return url.href;
    } catch (_) { return null; }
  }

  function errorMessage(code) {
    var messages = {
      REVIEWS_RATE_LIMIT: 'Please wait a few minutes before trying again.',
      REVIEWS_RATE_LIMITED: 'Please wait a few minutes before trying again.',
      REVIEWS_INVITATION_INVALID: 'This review link is no longer valid. Open your original review link or contact us for a new one.',
      REVIEWS_INVITATION_EXPIRED: 'This review link has expired. Please contact us for a new one.',
      REVIEWS_INVITATION_USED: 'A review has already been submitted using this link.',
      REVIEWS_ORDER_ALREADY_REVIEWED: 'A review has already been submitted for this order.',
      REVIEWS_SUBMISSION_CHANGED: 'The previous submission used different details. Please retry with the details you first submitted, or close this form to start a new review.',
      REVIEWS_INVALID_IMAGE: 'Please use a JPG, PNG or WebP photo, up to 2 MB each.',
      REVIEWS_IMAGE_TOO_LARGE: 'Each photo must be 2 MB or smaller.',
      REVIEWS_INVALID_INPUT: 'Please check your details and try again.',
      REVIEWS_INVALID_EMAIL: 'Please enter a valid email address.'
    };
    return messages[code] || 'We couldn’t confirm your submission. Please try again. Your entered review has been kept.';
  }

  function photoValidation(files) {
    if (files.length > 3) return 'You can add up to 3 photos.';
    for (var i = 0; i < files.length; i += 1) {
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(files[i].type)) return 'Please choose JPG, PNG or WebP photos.';
      if (files[i].size > 2 * 1024 * 1024) return 'Each photo must be 2 MB or smaller.';
      if (!files[i].size) return 'This photo is empty. Please choose another file.';
    }
    return '';
  }

  // Pure helpers are exported for the local contract checks; the shop runs this without a module loader.
  if (typeof module !== 'undefined' && module.exports) module.exports = { pageChoices: pageChoices, pictureUrl: pictureUrl, errorMessage: errorMessage, photoValidation: photoValidation };
  if (typeof document === 'undefined') return;
  if (window.__slimavaReviewsWidgetLoaded) return;
  window.__slimavaReviewsWidgetLoaded = true;

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }

  function icon(kind) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.7');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('sv-reviews__icon');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    var paths = {
      close: 'M6 6l12 12M6 18L18 6', check: 'M5 12l4 4L19 6',
      filter: 'M4 7h9m4 0h3M4 17h3m4 0h9M13 4v6M7 14v6',
      left: 'M15 5l-7 7 7 7', right: 'M9 5l7 7-7 7'
    };
    path.setAttribute('d', paths[kind] || paths.check);
    svg.appendChild(path);
    return svg;
  }

  function button(label, classes, handler) {
    var node = el('button', classes || 'sv-reviews__button', label);
    node.type = 'button';
    if (handler) node.addEventListener('click', handler);
    return node;
  }

  function stars(value) {
    var node = el('span', 'sv-reviews__stars');
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', value + ' out of 5 stars');
    for (var i = 1; i <= 5; i += 1) {
      var star = el('span', '', '★');
      star.setAttribute('aria-hidden', 'true');
      if (i > Math.round(value)) star.setAttribute('data-empty', '');
      node.appendChild(star);
    }
    return node;
  }

  function formatDate(value) {
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).format(date);
  }

  function uuid() {
    if (window.crypto.randomUUID) return window.crypto.randomUUID();
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, function (c) {
      return (Number(c) ^ window.crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(c) / 4).toString(16);
    });
  }

  function createWidget(root) {
    var productId = root.dataset.productId;
    if (!/^\d{5,25}$/.test(productId || '')) return;
    // The public origin is pinned. Theme attributes cannot turn this into an arbitrary submission destination.
    var endpoint = API_ORIGIN + '/api/slimava-reviews';
    var id = 'sv-review-' + (++instanceCount);
    var state = { page: 1, sort: null, rating: null, data: null, loading: false, serial: 0 };
    var activeRequest = null;
    var observer = null;
    var dialogs = [];
    var invitation = new URLSearchParams(window.location.search).get('review_token') || '';
    if (invitation.length > 4096) invitation = '';
    var invitationOpened = false;

    if (invitation) {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('review_token');
      window.history.replaceState(window.history.state, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    }

    function announce(text) {
      var status = root.querySelector('[data-review-status]');
      if (status) status.textContent = text;
    }

    function makeDialog(title, photo) {
      var previousFocus = document.activeElement;
      var dialog = el('dialog', 'sv-reviews-dialog' + (photo ? ' sv-reviews-dialog--photo' : ''));
      dialog.setAttribute('aria-label', title);
      if (state.data) dialog.style.setProperty('--sv-review-accent', state.data.settings.accentColor);
      var close = button('', 'sv-reviews-dialog__close', function () { dialog.close(); });
      close.setAttribute('aria-label', 'Close');
      close.appendChild(icon('close'));
      dialog.appendChild(close);
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () {
        dialog.remove();
        dialogs = dialogs.filter(function (item) { return item !== dialog; });
        if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
      });
      document.body.appendChild(dialog);
      dialogs.push(dialog);
      return dialog;
    }

    function openPhoto(picture) {
      var url = pictureUrl(picture.url);
      if (!url) return;
      var dialog = makeDialog('Customer photo', true);
      var image = el('img', 'sv-reviews-dialog__photo');
      image.src = url;
      image.alt = picture.alt || 'Customer photo';
      image.decoding = 'async';
      dialog.appendChild(image);
      if (picture.alt) dialog.appendChild(el('p', 'sv-reviews-dialog__caption', picture.alt));
      dialog.showModal();
    }

    function photoButton(picture) {
      var url = pictureUrl(picture.url);
      if (!url) return null;
      var node = button('', 'sv-reviews__picture-button', function () { openPhoto(picture); });
      node.setAttribute('aria-label', 'Open ' + (picture.alt || 'customer photo'));
      var image = el('img');
      image.src = url;
      image.alt = picture.alt || 'Customer photo';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 88;
      image.height = 88;
      node.appendChild(image);
      return node;
    }

    function renderFilters(data) {
      var details = el('details', 'sv-reviews__filters');
      var summary = el('summary', 'sv-reviews__button');
      summary.append(icon('filter'), document.createTextNode('Filter & sort'));
      details.appendChild(summary);
      var panel = el('div', 'sv-reviews__filter-panel');
      panel.appendChild(el('span', 'sv-reviews__filter-label', 'Filter by rating'));
      var histogram = el('div', 'sv-reviews__histogram');
      for (var rating = 5; rating >= 1; rating -= 1) {
        (function (value) {
          var count = Number(data.histogram[String(value)]) || 0;
          var row = button('', 'sv-reviews__histogram-button', function () {
            state.rating = state.rating === value ? null : value;
            state.page = 1;
            load(false);
          });
          row.setAttribute('aria-pressed', String(state.rating === value));
          row.setAttribute('aria-label', value + ' stars, ' + count + ' reviews');
          row.appendChild(el('span', 'sv-reviews__histogram-label', value + ' ★'));
          var track = el('span', 'sv-reviews__histogram-track');
          var fill = el('span', 'sv-reviews__histogram-fill');
          fill.style.width = Math.min(100, Math.max(0, data.count ? count / data.count * 100 : 0)) + '%';
          track.appendChild(fill);
          row.append(track, el('span', 'sv-reviews__histogram-count', count));
          histogram.appendChild(row);
        })(rating);
      }
      panel.appendChild(histogram);
      var label = el('label', 'sv-reviews__filter-label', 'Sort reviews');
      label.htmlFor = id + '-sort';
      var select = el('select', 'sv-reviews__select');
      select.id = label.htmlFor;
      SORTS.forEach(function (sort) {
        var option = el('option', '', sort[1]);
        option.value = sort[0];
        option.selected = sort[0] === state.sort;
        select.appendChild(option);
      });
      select.addEventListener('change', function () { state.sort = select.value; state.page = 1; load(false); });
      panel.append(label, select);
      panel.appendChild(button('Reset filters', 'sv-reviews__clear', function () {
        state.sort = data.settings.defaultSort;
        state.rating = null;
        state.page = 1;
        load(false);
      }));
      details.appendChild(panel);
      return details;
    }

    function renderReview(review, settings) {
      var article = el('article', 'sv-reviews__review');
      article.setAttribute('aria-label', 'Review by ' + review.authorName);
      var top = el('div', 'sv-reviews__review-top');
      top.appendChild(stars(review.rating));
      if (settings.showDates) {
        var date = el('time', 'sv-reviews__date', formatDate(review.createdAt));
        date.dateTime = review.createdAt;
        top.appendChild(date);
      }
      var author = el('div', 'sv-reviews__author');
      author.appendChild(el('span', 'sv-reviews__author-name', review.authorName));
      if (settings.showVerified && review.verified === true) {
        var verified = el('span', 'sv-reviews__verified');
        verified.append(icon('check'), document.createTextNode('Verified buyer'));
        author.appendChild(verified);
      }
      article.append(top, author);
      if (review.title) article.appendChild(el('h3', 'sv-reviews__review-title', review.title));
      article.appendChild(el('p', 'sv-reviews__body', review.body));
      if (settings.showPhotos && review.pictures.length) {
        var photos = el('div', 'sv-reviews__review-pictures');
        review.pictures.forEach(function (picture) { var node = photoButton(picture); if (node) photos.appendChild(node); });
        article.appendChild(photos);
      }
      if (review.reply) {
        var reply = el('div', 'sv-reviews__reply');
        reply.append(el('strong', 'sv-reviews__reply-name', 'Reply from Slimava'), el('p', 'sv-reviews__body', review.reply));
        article.appendChild(reply);
      }
      return article;
    }

    function render(data) {
      var settings = data.settings;
      if (/^#[\da-f]{6}$/i.test(settings.accentColor)) root.style.setProperty('--sv-review-accent', settings.accentColor);
      var content = document.createDocumentFragment();
      content.appendChild(el('h2', 'sv-reviews__title', settings.heading));
      var header = el('div', 'sv-reviews__head');
      var summary = el('div');
      var rating = el('div', 'sv-reviews__rating-line');
      rating.append(stars(data.average), el('span', 'sv-reviews__average', data.count ? Number(data.average).toFixed(1) + ' / 5' : 'No reviews yet'));
      summary.append(rating, el('p', 'sv-reviews__count', data.count ? 'Based on ' + data.count.toLocaleString('en-US') + ' reviews' : 'Be the first to share your experience.'));
      var actions = el('div', 'sv-reviews__actions');
      if (settings.showWriteButton) actions.appendChild(button(settings.writeButtonText, 'sv-reviews__button sv-reviews__button--primary', openForm));
      actions.appendChild(renderFilters(data));
      header.append(summary, actions);
      content.appendChild(header);
      if (settings.showPhotos && data.gallery.length) {
        var gallery = el('div', 'sv-reviews__gallery');
        gallery.setAttribute('aria-label', 'Customer photos');
        data.gallery.forEach(function (picture) { var node = photoButton(picture); if (node) gallery.appendChild(node); });
        content.appendChild(gallery);
      }
      var status = el('div', 'sv-reviews__status');
      status.dataset.reviewStatus = '';
      status.setAttribute('role', 'status');
      if (state.rating) status.textContent = data.total + ' reviews with ' + state.rating + ' stars';
      else if (state.sort === 'pictures') status.textContent = data.total + ' reviews with photos';
      content.appendChild(status);
      var list = el('div', 'sv-reviews__list');
      list.setAttribute('aria-label', 'Customer reviews');
      if (!data.items.length) list.appendChild(el('p', 'sv-reviews__empty', data.count ? 'No reviews match these filters.' : 'Your experience could help someone else.'));
      data.items.forEach(function (review) { list.appendChild(renderReview(review, settings)); });
      content.appendChild(list);
      if (data.pages > 1) {
        var pagination = el('nav', 'sv-reviews__pagination');
        pagination.setAttribute('aria-label', 'Review pages');
        function go(page) { state.page = page; load(true); }
        if (data.page > 1) {
          var previous = button('', 'sv-reviews__page', function () { go(data.page - 1); });
          previous.setAttribute('aria-label', 'Previous review page');
          previous.appendChild(icon('left'));
          pagination.appendChild(previous);
        }
        pageChoices(data.page, data.pages).forEach(function (page) {
          if (page === '…') { pagination.appendChild(el('span', 'sv-reviews__page', '…')); return; }
          var pageButton = button(String(page), 'sv-reviews__page', function () { go(page); });
          pageButton.setAttribute('aria-label', 'Review page ' + page);
          if (page === data.page) pageButton.setAttribute('aria-current', 'page');
          pagination.appendChild(pageButton);
        });
        if (data.page < data.pages) {
          var next = button('', 'sv-reviews__page', function () { go(data.page + 1); });
          next.setAttribute('aria-label', 'Next review page');
          next.appendChild(icon('right'));
          pagination.appendChild(next);
        }
        content.appendChild(pagination);
      }
      root.replaceChildren(content);
    }

    function readPhoto(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve({ contentType: file.type, base64: String(reader.result).split(',')[1] }); };
        reader.onerror = function () { reject(new Error('PHOTO_READ')); };
        reader.readAsDataURL(file);
      });
    }

    function openForm() {
      if (!state.data) return;
      var dialog = makeDialog('Write a review', false);
      dialog.append(el('h3', 'sv-reviews-dialog__title', 'Share your experience'), el('p', 'sv-reviews-dialog__intro', root.dataset.productTitle || 'Slimava'));
      var form = el('form', 'sv-reviews-form');
      var submissionId = uuid();
      var submitting = false;
      var photoUrls = [];
      var fields = {};
      var ratingGroup = el('fieldset', 'sv-reviews-form__rating');
      ratingGroup.appendChild(el('legend', '', 'Your rating'));
      var ratingRow = el('div', 'sv-reviews-form__stars');
      for (var value = 1; value <= 5; value += 1) {
        var starLabel = el('label', 'sv-reviews-form__star');
        var radio = el('input');
        radio.type = 'radio'; radio.name = 'rating'; radio.value = String(value); radio.required = true;
        radio.setAttribute('aria-label', value + (value === 1 ? ' star' : ' stars'));
        radio.addEventListener('change', function (event) {
          var selected = Number(event.target.value);
          Array.from(ratingRow.children).forEach(function (label, index) { label.toggleAttribute('data-filled', index < selected); });
        });
        var starText = el('span', '', '★');
        starText.setAttribute('aria-hidden', 'true');
        starLabel.append(radio, starText); ratingRow.appendChild(starLabel);
      }
      ratingGroup.appendChild(ratingRow); form.appendChild(ratingGroup);

      function field(name, label, type, required, max, hint) {
        var wrapper = el('label', 'sv-reviews-form__field', label);
        var input = el(type === 'textarea' ? 'textarea' : 'input');
        if (type !== 'textarea') input.type = type;
        input.name = name; input.required = required; input.maxLength = max;
        if (name === 'email') input.autocomplete = 'email';
        if (name === 'authorName') input.autocomplete = 'name';
        wrapper.appendChild(input);
        if (hint) wrapper.appendChild(el('span', 'sv-reviews-form__hint', hint));
        form.appendChild(wrapper); fields[name] = input;
      }
      field('authorName', 'Your name', 'text', true, 80, 'This name will appear with your review.');
      field('email', 'Email address', 'email', true, 254, 'Your email address will never be shown publicly.');
      field('title', 'Review title (optional)', 'text', false, 160);
      field('body', 'Your review', 'textarea', true, 5000);

      var files = null;
      var previews = el('div', 'sv-reviews-form__photos');
      var message = el('p', 'sv-reviews-form__message');
      message.setAttribute('role', 'status');
      function revokePhotos() { photoUrls.forEach(function (url) { URL.revokeObjectURL(url); }); photoUrls = []; }
      if (state.data.settings.showPhotos) {
        var photoField = el('label', 'sv-reviews-form__field', 'Add photos (optional)');
        files = el('input'); files.type = 'file'; files.accept = 'image/jpeg,image/png,image/webp'; files.multiple = true;
        files.addEventListener('change', function () {
          revokePhotos(); previews.replaceChildren();
          var selected = Array.from(files.files || []);
          var error = photoValidation(selected);
          message.textContent = error;
          if (error) return;
          selected.forEach(function (file) {
            var url = URL.createObjectURL(file); photoUrls.push(url);
            var preview = el('img', 'sv-reviews-form__photo'); preview.src = url; preview.alt = 'Selected photo'; previews.appendChild(preview);
          });
        });
        photoField.append(files, el('span', 'sv-reviews-form__hint', 'Up to 3 JPG, PNG or WebP photos. Maximum 2 MB each.'));
        form.append(photoField, previews);
      }
      var trap = el('label', 'sv-reviews-form__trap', 'Website');
      trap.setAttribute('aria-hidden', 'true');
      var website = el('input'); website.type = 'text'; website.name = 'website'; website.tabIndex = -1; website.autocomplete = 'off'; trap.appendChild(website);
      var submit = button('Submit review', 'sv-reviews__button sv-reviews__button--primary sv-reviews-form__submit'); submit.type = 'submit';
      form.append(trap, el('p', 'sv-reviews-form__notice', 'Reviews are checked before they appear in the shop.'), message, submit);
      dialog.addEventListener('close', revokePhotos, { once: true });
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (submitting) { message.textContent = 'Your review is being submitted…'; return; }
        var selected = files ? Array.from(files.files || []) : [];
        var invalidPhotos = photoValidation(selected);
        if (invalidPhotos) { message.textContent = invalidPhotos; return; }
        if (!fields.authorName.value.trim() || !fields.body.value.trim()) { message.textContent = 'Please enter your name and review.'; return; }
        submitting = true;
        submit.textContent = 'Submitting…';
        submit.setAttribute('aria-busy', 'true');
        message.textContent = '';
        var controller = new AbortController();
        var timer = window.setTimeout(function () { controller.abort(); }, 30000);
        try {
          var photos = await Promise.all(selected.map(readPhoto));
          var payload = {
            productId: productId, authorName: fields.authorName.value.trim(), email: fields.email.value.trim(),
            rating: Number(new FormData(form).get('rating')), title: fields.title.value.trim(), body: fields.body.value.trim(),
            photos: photos, submissionId: submissionId, website: website.value
          };
          if (invitation) payload.invitationToken = invitation;
          var response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), credentials: 'omit', referrerPolicy: 'origin', signal: controller.signal });
          var result = await response.json();
          if (!response.ok || result.accepted !== true) {
            // A rejected input can be corrected. Keep the same id after an unknown network/server outcome.
            if (response.status === 400 || response.status === 413 || response.status === 429) submissionId = uuid();
            throw new Error(result.error || 'REVIEWS_SUBMISSION_FAILED');
          }
          invitation = '';
          if (!dialog.isConnected) return;
          revokePhotos();
          var success = el('div', 'sv-reviews-dialog__success');
          success.setAttribute('role', 'status');
          var mark = el('span', 'sv-reviews-dialog__success-icon'); mark.appendChild(icon('check'));
          success.append(mark, el('h3', '', 'Thank you for your review'), el('p', '', state.data.settings.submitSuccessText || 'Your review has been received and will appear after it has been checked.'));
          success.appendChild(button('Done', 'sv-reviews__button sv-reviews__button--primary', function () { dialog.close(); }));
          Array.from(dialog.children).forEach(function (child) { if (!child.classList.contains('sv-reviews-dialog__close')) child.remove(); });
          dialog.appendChild(success);
          success.querySelector('button').focus();
        } catch (error) {
          if (dialog.isConnected) message.textContent = errorMessage(error.message);
        } finally {
          window.clearTimeout(timer); submitting = false; submit.textContent = 'Submit review'; submit.removeAttribute('aria-busy');
        }
      });
      dialog.appendChild(form); dialog.showModal();
    }

    async function load(scroll) {
      if (activeRequest) activeRequest.abort();
      activeRequest = new AbortController();
      var request = activeRequest;
      var serial = ++state.serial;
      state.loading = true; root.setAttribute('aria-busy', 'true'); announce('Loading reviews…');
      var params = new URLSearchParams({ productId: productId, page: String(state.page) });
      if (state.sort) params.set('sort', state.sort);
      if (state.rating) params.set('rating', String(state.rating));
      var timedOut = false;
      var timer = window.setTimeout(function () { timedOut = true; request.abort(); }, 15000);
      try {
        var response = await fetch(endpoint + '?' + params.toString(), { credentials: 'omit', referrerPolicy: 'origin', signal: request.signal });
        if (!response.ok) throw new Error('REVIEWS_READ_FAILED');
        var data = await response.json();
        if (!data || data.version !== 1 || !Array.isArray(data.items) || !data.settings || data.productId !== productId) throw new Error('REVIEWS_RESPONSE_INVALID');
        if (serial !== state.serial || !root.isConnected) return;
        state.data = data; state.page = data.page;
        if (!state.sort) state.sort = data.settings.defaultSort;
        render(data);
        if (scroll) {
          var heading = root.querySelector('.sv-reviews__title');
          heading.tabIndex = -1; heading.focus({ preventScroll: true });
          root.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
        if (invitation && !invitationOpened) { invitationOpened = true; openForm(); }
      } catch (error) {
        if (serial !== state.serial || !root.isConnected || (error.name === 'AbortError' && !timedOut)) return;
        if (!state.data) root.replaceChildren();
        else { announce('Reviews could not be refreshed. The previous reviews are still shown.'); }
        var oldError = root.querySelector('.sv-reviews__failure'); if (oldError) oldError.remove();
        var failure = el('div', 'sv-reviews__failure');
        failure.setAttribute('role', 'status');
        failure.append(el('p', '', 'We couldn’t load the reviews right now.'), button('Try again', 'sv-reviews__button', function () { load(scroll); }));
        root.appendChild(failure);
      } finally {
        window.clearTimeout(timer);
        if (serial === state.serial) { state.loading = false; root.removeAttribute('aria-busy'); }
      }
    }

    function start() { if (observer) observer.disconnect(); load(false); }
    if (invitation || !('IntersectionObserver' in window)) start();
    else {
      observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) start(); }, { rootMargin: '700px' });
      observer.observe(root);
    }
    return function () { if (observer) observer.disconnect(); if (activeRequest) activeRequest.abort(); dialogs.slice().forEach(function (dialog) { dialog.close(); }); };
  }

  function mount(container) {
    var roots = Array.from(container.querySelectorAll('[data-slimava-reviews]'));
    if (container.matches && container.matches('[data-slimava-reviews]')) roots.unshift(container);
    roots.forEach(function (root) { if (!mounted.has(root)) mounted.set(root, createWidget(root)); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-slimava-reviews]').forEach(function (root) { var destroy = mounted.get(root); if (destroy) destroy(); mounted.delete(root); });
  });
})();
